import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/guanzhued.png'
import _imports_1 from '@/assets/image/guanzhu.png'


const _withScopeId = n => (_pushScopeId("data-v-aab60f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    "data-follow-fill": "#2E4968",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M3.288 8.177V6.583h8.86a5.3 5.3 0 1 1 0 10.6l-5.702-.001v-1.594h5.695a3.706 3.706 0 0 0 0-7.41l-8.853-.001Z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M3.296 6.583 9.33 3.071l.801 1.322-5.903 3.47-.18.1h-.752z" })
  ])
], -1))
const _hoisted_2 = { class: "mb_10" }
const _hoisted_3 = { class: "brand-goods mb_30" }
const _hoisted_4 = { class: "title-1" }
const _hoisted_5 = { class: "flex-wrap-ter mt_10 mb_30" }
const _hoisted_6 = {
  key: 0,
  class: "flex"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "fx-1 text-rt mr_20" }
const _hoisted_9 = { class: "goods flex-wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  style: {"height":"100%","width":"100%"}
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  style: {"height":"100%","width":"100%"}
}
const _hoisted_14 = { class: "goods-text" }
const _hoisted_15 = { class: "mt_5 price flex" }
const _hoisted_16 = { class: "mr_5" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { style: {"color":"#232323"} }
const _hoisted_19 = { class: "page flex-end mr_30" }

import { t } from '@/plugins/i18n'
import { useRoute, useRouter } from 'vue-router'
import useCate from '../components/cate'
import { ref, reactive } from 'vue'
import { useRtfix, useSite, useSite2Station, isMultiStore, isJA } from '@/store'
import BrandCard from '../components/BrandCard.vue'
import { productFavorite, productFavoriteCancel, handleProductBehavior } from '@/apis/goods'
import { searchProducts } from '@/apis/search'
import { ElMessage as message } from 'element-plus'
import { formatMoneyDirection, showCurrentUnit } from '@/util/useYan'
import SearchInput from '../components/SearchInput.vue'
import { brandQuery } from '@/apis/brand'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const id = route.params.brand?.toString()

const platform = [
  { value: '', label: t('全部') },
  { value: 'AM', label: t('1688') },
  { value: 'TB', label: t('淘宝') },
  { value: 'TM', label: t('Tmall') }
]

const cate = [{ value: null, label: t('全部类目') }].concat(useCate().value)

const filters = [
  { prop: 'sevenDaysNew', value: 0, label: '全部_' },
  { prop: 'sevenDaysNew', value: 1, label: '7日上新' }
].fort()

// 品牌卡片数据
const data = ref(null)
brandQuery({ brandId: id }).setSite(res => {
  if (res.success) {
    data.value = res.data
  }
})

// 筛选
const params = reactive<any>({
  pageNum: 1,
  pageSize: 20,
  total: 20,
  channel: 0,
  brandId: id,
  productCategoryFrontendId: null,
  keyword: '',
  langType: null,
  platformType: '',
  sevenDaysNew: 0
})

const currentChange = (e: number) => {
  params.pageNum = e
  query()
}

const sizeChange = (e: number) => {
  params.pageSize = e
  query()
}

const set = ([prop, value]:[any, any]) => {
  params[prop] = value
  // 特殊处理
  if (prop === 'sevenDaysNew' && value === 0) {
    params.productCategoryFrontendId = null
    params.platformType = ''
  }
  query()
}

const query = () => {
  searchProducts(params).then(res => {
    const data = res.data
    goods.value = data.records
    params.total = data.total
  })
}

const handleSearch = (data:any) => {
  console.log(data)
  Object.keys(data).forEach(v => {
    params[v] = data[v]
  })
  query()
}

query()

// 商品
const goods = ref<any[]>([])

const guanzhu = (item:any) => {
  console.log(item)
  if (item.favoriteFlag) {
    // 取消收藏
    // 请求前先反馈
    item.favoriteFlag = 0
    productFavoriteCancel(item).then(res => {
      if (res.code === '0') {
      }
    })
  } else {
    // 添加收藏
    // 请求前先反馈
    item.favoriteFlag = 1
    message.success(t('商品收藏成功'))
    productFavorite(item).then(res => {
      if (res.code === '0') {
      }
    })
  }
}

const goBack = () => {
  router.go(-1)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["viewport pt_10", 'brand-detail-' + _unref(useSite)()])
  }, [
    _createElementVNode("div", {
      class: "backBtn flex-cen-ter cursor-pt",
      onClick: goBack
    }, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_unref(t)('返回')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (data.value)
        ? (_openBlock(), _createBlock(BrandCard, {
            key: 0,
            data: data.value
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('所有商品')), 1),
      _createElementVNode("div", _hoisted_5, [
        (data.value?.countryCode !== 'KR')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.label,
                  onClick: ($event: any) => (set([v.prop,v.value])),
                  class: _normalizeClass([_unref(params)[v.prop]===v.value&&'active', "filter-label mr_20"])
                }, _toDisplayString(v.label), 11, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SearchInput, { search: handleSearch })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goods.value, (v) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.productCode,
            class: "goods-item rel flex-col mr_20 mb_20"
          }, [
            _createVNode(_component_router_link, {
              to: _unref(useRtfix)('goods', { params: { id: v.productCode } }),
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  referrerPolicy: "no-referrer",
                  "data-goods": "",
                  class: "wrap",
                  src: v.productMainImg,
                  alt: v.productTitle,
                  fit: "cover",
                  lazy: ""
                }, {
                  error: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["src", "alt"])
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("div", {
              class: "abs guanzhu",
              onClick: ($event: any) => (guanzhu(v))
            }, [
              (v.favoriteFlag)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : (_openBlock(), _createElementBlock("img", _hoisted_13))
            ], 8, _hoisted_11),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_router_link, {
                class: "title-3",
                target: "_blank",
                to: _unref(useRtfix)('goods', { params: { id: v.productCode } })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(v.productTitle)), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(v.productSellPrice||v.productSellPriceRange), 1),
                  (_unref(isJA)())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(showCurrentUnit)(v.country === 'KR')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_18, " (" + _toDisplayString(_unref(formatMoneyDirection)(v.productSellPriceRangeJpy||v.productSellPriceJpy)) + ") ", 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev,pager,next",
          currentPage: _unref(params).pageNum,
          "page-size": _unref(params).pageSize,
          total: _unref(params).total,
          onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (currentChange($event))),
          onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (sizeChange($event)))
        }, null, 8, ["currentPage", "page-size", "total"])
      ])
    ])
  ], 2))
}
}

})